import { render, staticRenderFns } from "./ArtFact.vue?vue&type=template&id=f9980764&scoped=true&"
import script from "./ArtFact.vue?vue&type=script&lang=js&"
export * from "./ArtFact.vue?vue&type=script&lang=js&"
import style0 from "./ArtFact.vue?vue&type=style&index=0&id=f9980764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9980764",
  null
  
)

export default component.exports